import merge from 'deepmerge'
import isPlainObject from 'lodash/isPlainObject'

export default function(obj1, obj2, options = {}) {
  return merge(obj1, obj2, {
    isMergeableObject: isPlainObject,
    ...options
  })
}
